import BezelBlackWhite from "../images/customisation-assets/Bezel_Black_White.png";
import BezelBlackGreen from "../images/customisation-assets/Bezel_Black_Green.png";
import BezelAqua from "../images/customisation-assets/Bezel_Aqua.png";
import BezelBlueOrange from "../images/customisation-assets/Bezel_Blue_Orange.png";
import BezelBlueWhite from "../images/customisation-assets/Bezel_Blue_White.png";
import BezelBrownSand from "../images/customisation-assets/Bezel_Brown_Sand.png";
import BezelOrangeGreen from "../images/customisation-assets/Bezel_Orange_Green.png";
import BezelRedBlue from "../images/customisation-assets/Bezel_Red_Blue.png";
import BezelRedWhite from "../images/customisation-assets/Bezel_Red_White.png";
import BezelPink from "../images/customisation-assets/Bezel_Pink.png";
import BezelBlueYellow from "../images/customisation-assets/Bezel_Blue_Yellow.png";
import BezelBlueRed from "../images/customisation-assets/Bezel_Blue_Red.png";
import BezelNavyBlue from "../images/customisation-assets/Bezel_Navy_Blue.png";
import BezelBlackOrange from "../images/customisation-assets/Bezel_Black_Orange.png";
import BezelYellow from "../images/customisation-assets/Bezel_Yellow.png";
import BezelBlackRed from "../images/customisation-assets/Bezel_Black_Red.png";
import BezelBlackLightGreen from "../images/customisation-assets/Bezel_Black_Light_Green.png";
import BezelBlackGold from "../images/customisation-assets/Bezel_Black_Gold.png";

// Thumbnails
import BezelBlackWhiteThumb from "../images/customisation-asset-thumbnails/Bezel_Black_White_50x50.png";
import BezelBlackGreenThumb from "../images/customisation-asset-thumbnails/Bezel_Black_Green_50x50.png";
import BezelAquaThumb from "../images/customisation-asset-thumbnails/Bezel_Aqua_50x50.png";
import BezelBlueOrangeThumb from "../images/customisation-asset-thumbnails/Bezel_Blue_Orange_50x50.png";
import BezelBlueWhiteThumb from "../images/customisation-asset-thumbnails/Bezel_Blue_White_50x50.png";
import BezelBrownSandThumb from "../images/customisation-asset-thumbnails/Bezel_Brown_Sand_50x50.png";
import BezelOrangeGreenThumb from "../images/customisation-asset-thumbnails/Bezel_Orange_Green_50x50.png";
import BezelRedBlueThumb from "../images/customisation-asset-thumbnails/Bezel_Red_Blue_50x50.png";
import BezelRedWhiteThumb from "../images/customisation-asset-thumbnails/Bezel_Red_White_50x50.png";
import BezelPinkThumb from "../images/customisation-asset-thumbnails/Bezel_Pink_50x50.png";
import BezelBlueYellowThumb from "../images/customisation-asset-thumbnails/Bezel_Blue_Yellow_50x50.png";
import BezelBlueRedThumb from "../images/customisation-asset-thumbnails/Bezel_Blue_Red_50x50.png";
import BezelNavyBlueThumb from "../images/customisation-asset-thumbnails/Bezel_Navy_Blue_50x50.png";
import BezelBlackOrangeThumb from "../images/customisation-asset-thumbnails/Bezel_Black_Orange_50x50.png";
import BezelYellowThumb from "../images/customisation-asset-thumbnails/Bezel_Yellow_50x50.png";
import BezelBlackRedThumb from "../images/customisation-asset-thumbnails/Bezel_Black_Red_50x50.png";
import BezelBlackLightGreenThumb from "../images/customisation-asset-thumbnails/Bezel_Black_Light_Green_50x50.png";
import BezelBlackGoldThumb from "../images/customisation-asset-thumbnails/Bezel_Black_Gold_50x50.png";

import { SelectionColours } from "./selection-colors";

export const BEZEL_OPTIONS = {
  blackWhite: {
    title: "Black & White",
    watchLayerAsset: BezelBlackWhite,
    watchLayerThumbnail: BezelBlackWhiteThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.LIGHT_BLACK, SelectionColours.WHITE],
    },
  },
  blackGreen: {
    title: "Black & Green",
    watchLayerAsset: BezelBlackGreen,
    watchLayerThumbnail: BezelBlackGreenThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.DARK_GREEN, SelectionColours.GREEN],
    },
  },
  aqua: {
    title: "Aqua",
    watchLayerAsset: BezelAqua,
    watchLayerThumbnail: BezelAquaThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.AQUA],
    },
  },
  blueOrange: {
    title: "Blue & Orange",
    watchLayerAsset: BezelBlueOrange,
    watchLayerThumbnail: BezelBlueOrangeThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.DARK_BLUE, SelectionColours.ORANGE],
    },
  },
  blueWhite: {
    title: "Blue & White",
    watchLayerAsset: BezelBlueWhite,
    watchLayerThumbnail: BezelBlueWhiteThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.DARK_BLUE, SelectionColours.WHITE],
    },
  },
  brownSand: {
    title: "Brown & Sand",
    watchLayerAsset: BezelBrownSand,
    watchLayerThumbnail: BezelBrownSandThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BROWN, SelectionColours.SAND],
    },
  },
  orangeGreen: {
    title: "Orange & Green",
    watchLayerAsset: BezelOrangeGreen,
    watchLayerThumbnail: BezelOrangeGreenThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.ORANGE, SelectionColours.DARK_CYAN],
    },
  },
  redBlue: {
    title: "Red & Blue",
    watchLayerAsset: BezelRedBlue,
    watchLayerThumbnail: BezelRedBlueThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.RED, SelectionColours.BLUE],
    },
  },
  redWhite: {
    title: "Red & White",
    watchLayerAsset: BezelRedWhite,
    watchLayerThumbnail: BezelRedWhiteThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.RED, SelectionColours.WHITE],
    },
  },
  pink: {
    title: "Pink",
    watchLayerAsset: BezelPink,
    watchLayerThumbnail: BezelPinkThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.PINK],
    },
  },
  blueYellow: {
    title: "Blue & Yellow",
    watchLayerAsset: BezelBlueYellow,
    watchLayerThumbnail: BezelBlueYellowThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.DARK_BLUE, SelectionColours.YELLOW],
    },
  },
  blueRed: {
    title: "Blue & Red",
    watchLayerAsset: BezelBlueRed,
    watchLayerThumbnail: BezelBlueRedThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BLUE, SelectionColours.RED],
    },
  },
  navyBlue: {
    title: "Navy & Blue",
    watchLayerAsset: BezelNavyBlue,
    watchLayerThumbnail: BezelNavyBlueThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.NAVY, SelectionColours.LIGHT_BLUE],
    },
  },
  blackOrange: {
    title: "Black & Orange",
    watchLayerAsset: BezelBlackOrange,
    watchLayerThumbnail: BezelBlackOrangeThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BLACK, SelectionColours.ORANGE],
    },
  },
  yellow: {
    title: "Yellow",
    watchLayerAsset: BezelYellow,
    watchLayerThumbnail: BezelYellowThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.YELLOW],
    },
  },
  blackRed: {
    title: "Black & Red",
    watchLayerAsset: BezelBlackRed,
    watchLayerThumbnail: BezelBlackRedThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BLACK, SelectionColours.RED],
    },
  },
  blackLightGreen: {
    title: "Black & Light Green",
    watchLayerAsset: BezelBlackLightGreen,
    watchLayerThumbnail: BezelBlackLightGreenThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BLACK, SelectionColours.FOREST_GREEN],
    },
  },
  blackGold: {
    title: "Black & Gold",
    watchLayerAsset: BezelBlackGold,
    watchLayerThumbnail: BezelBlackGoldThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BLACK, SelectionColours.GOLD],
    },
  },
};
